import React, { useEffect } from 'react';
import * as icons from './icons.json';
import { urlToPublic } from 'shared/utils/helpers';
import log from 'shared/utils/log';

export type IconName = keyof typeof icons;

interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon: IconName;
}

const SPRITE_ID = 'sb-svg-sprite';

export const Icon: React.FC<IconProps> = ({ icon, ...props }) => {
  return (
    <svg {...props}>
      <use href={`#sb-svg-${icon}`} />
    </svg>
  );
};

export const useSvgSprite = () => {
  useEffect(() => {
    if (document.getElementById(SPRITE_ID)) return;

    const loadSVGSprite = async () => {
      try {
        const response = await fetch(
          urlToPublic(`/sprite.${process.env.SVG_SPRITE_HASH}.svg`),
        );
        const svgText = await response.text();

        const div = document.createElement('div');
        div.innerHTML = svgText;
        div.id = SPRITE_ID;
        div.style.display = 'none';

        document.body.appendChild(div);
      } catch (error) {
        log.error('Error loading SVG sprite:', error);
      }
    };

    loadSVGSprite();
  }, []);
};
